import { render, staticRenderFns } from "./_specification.vue?vue&type=template&id=12142831"
import script from "./_specification.vue?vue&type=script&lang=js"
export * from "./_specification.vue?vue&type=script&lang=js"
import style0 from "./_specification.vue?vue&type=style&index=0&id=12142831&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports